package one.devsbox.www.ui.users.edit

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import compose.assets.Svg
import compose.assets.svg.ContentSaveOutline
import kotlinx.coroutines.launch
import one.devsbox.shared.ads.SharedIO
import one.devsbox.www.io.Repository
import one.devsbox.www.ui.widgets.ScreenContentAction
import one.devsbox.www.www_portal.generated.resources.*
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.log.logINFO
import tk.mallumo.utils.DataState

@VM
class UserEVM : NavigationViewModel() {
    private lateinit var ctx: UserECtx

    var contentActions by mutableStateOf<List<ScreenContentAction>>(emptyList())
        private set

    var warningMessage by mutableStateOf<String?>(null)
        private set

    var state by mutableStateOf<DataState<UserECtx.Editor>>(DataState.Loading())
        private set

    fun setup(ctx: UserECtx) {
        this.ctx = ctx
        if (state is DataState.Loading) {
            loadUser(ctx.args.id)
        }
    }

    private fun loadUser(id: Long) {
        if (id < 1) {
            val user = SharedIO.User()
            val editor = UserECtx.Editor(scope, user)
            state = DataState.Result(editor)
            setupActions(editor)
        } else {
            state = DataState.Loading()
            scope.launch {
                runCatching {
                    Repository.ads.user.get(id)
                }.onSuccess { user ->
                    val editor = UserECtx.Editor(scope, user)
                    state = DataState.Result(editor)
                    setupActions(editor)
                }.onFailure {
                    state = DataState.Error(it.message ?: "Unknown error")
                    contentActions = emptyList()
                }
            }
        }
    }

    interface Action {
        fun save()
        fun clearWarning()
        fun back()
        fun reload()
    }

    val action = object : Action {
        override fun save() {
            val editor = state.entry ?: return
            state = DataState.Loading(editor)
            scope.launch {
                logINFO(editor.user.permission.toString())
                logINFO(editor.permissions.toString())

                runCatching {
                    val body = SharedIO.UserNew(
                        name = editor.user.name,
                        login = editor.user.login,
                        permission = editor.user.permission
                    )
                    if (ctx.args.id < 1) {
                        Repository.ads.user.add(body)
                    } else {
                        Repository.ads.user.change(ctx.args.id, body)
                    }
                }.onSuccess {
                    ctx.nav.up()
                }.onFailure {
                    state = DataState.Result(editor)
                    warningMessage = it.message ?: "Save failed"
                }
            }
        }

        override fun clearWarning() {
            warningMessage = null
        }

        override fun back() {
            ctx.nav.up()
        }

        override fun reload() {
            loadUser(ctx.args.id)
        }
    }

    private fun setupActions(editor: UserECtx.Editor) {
        contentActions = buildList {
            add(
                ScreenContentAction(
                    text = Res.string.ui_users_edit_btn_save,
                    color = ctx.colorPrimaryContainer,
                    icon = Svg.ContentSaveOutline
                ) {
                    action.save()
                }
            )
        }
    }

    override fun onRelease() {}
}
